import { useQuery } from '@tanstack/react-query';
import { getTimeTillEndOfDayMs } from '@toggle/helpers';

import { getWatchlistSummary } from '~/api/watchlist-summary/watchlist-summary-service';

export const QUERY_KEY_WATCHLIST_SUMMARY = 'QUERY_KEY_WATCHLIST_SUMMARY';

export const useWatchlistSummary = (watchlistId: string) =>
  useQuery({
    queryKey: [QUERY_KEY_WATCHLIST_SUMMARY, watchlistId],
    queryFn: ({ signal }) => getWatchlistSummary({ watchlistId, signal }),
    staleTime: getTimeTillEndOfDayMs(),
  });
